import { useMutation, useQueryClient } from '@tanstack/react-query';
import type AgentApiAiJobSearchPersonasItem from '@/types/serializers/AgentApiAiJobSearchPersonasItem';
import type SharedAiSourceSelection from '@/types/serializers/SharedAiSourceSelection';

type RebuildPersonaRequest = {
  id: number;
  selected_sources?: string[];
  /** カテゴリ内の個別ID選択（決定1: custom_data / candidate_interview_log の絞り込み） */
  source_selection?: Partial<SharedAiSourceSelection>;
  free_text?: string;
  uploaded_file_signed_ids?: string[];
};

/** ペルソナを再構築（queued に戻して再ビルド）するミューテーション */
export default function useRebuildAiJobSearchPersona() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      selected_sources,
      source_selection,
      free_text,
      uploaded_file_signed_ids,
    }: RebuildPersonaRequest): Promise<AgentApiAiJobSearchPersonasItem> => {
      const response = await fetch(`/agent/api/ai_job_search_personas/${id}/rebuild`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          selected_sources,
          source_selection,
          free_text,
          uploaded_file_signed_ids,
        }),
      });

      if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        const message =
          typeof errorBody?.message === 'string'
            ? errorBody.message
            : 'ペルソナの再構築に失敗しました';
        throw new Error(message);
      }

      const data: AgentApiAiJobSearchPersonasItem = await response.json();
      return data;
    },
    onSuccess: (data) => {
      // キャッシュを更新してポーリングを再開する
      queryClient.setQueryData(['aiJobSearchPersona', data.id], data);
    },
  });
}
